module.exports = __webpack_public_path__ + "static/img/Nuvolos-transparent.cf1c3b99.svg";